import React from 'react';
import './FormikForm.scss';

const FormikForm = () =>  {

  return (

    <div className="main-right-side-section">
      <div className="formik-main-section">
        <section>
          <div className="formik-section-1">
            <div className="formik-section-1-inner">
              <p>FormikForm Component</p>
            </div>
          </div>
        </section>
      </div>
    </div>
    
  );
}

FormikForm.propTypes = {};

FormikForm.defaultProps = {};

export default FormikForm;
